export default __webpack_public_path__ + "static/media/fish&chips-Regular.fa55ffd1.woff2";